/* labmat.js — header behaviour: hover mega-menu, mobile drawer, scroll-hide, lang pill */
(function(){
  'use strict';

  function bindMegaMenu(){
    var area = document.querySelector('.js-nav-orange');
    if(!area) return;
    var wraps = area.querySelectorAll('.js-nav-link[data-menu]');
    var menus = area.querySelectorAll('.js-mega-menu');
    var openKey = null;
    var closeTimer = null;

    function open(key){
      if(closeTimer){ clearTimeout(closeTimer); closeTimer = null; }
      openKey = key;
      wraps.forEach(function(w){
        w.classList.toggle('is-open', w.getAttribute('data-menu') === key);
      });
      menus.forEach(function(m){
        m.classList.toggle('is-open', m.getAttribute('data-menu') === key);
      });
    }
    function scheduleClose(){
      if(closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function(){
        openKey = null;
        wraps.forEach(function(w){ w.classList.remove('is-open'); });
        menus.forEach(function(m){ m.classList.remove('is-open'); });
      }, 120);
    }
    function cancelClose(){
      if(closeTimer){ clearTimeout(closeTimer); closeTimer = null; }
    }

    wraps.forEach(function(w){
      var key = w.getAttribute('data-menu');
      w.addEventListener('mouseenter', function(){ open(key); });
      w.addEventListener('mouseleave', scheduleClose);
      w.addEventListener('focusin', function(){ open(key); });
    });
    menus.forEach(function(m){
      m.addEventListener('mouseenter', cancelClose);
      m.addEventListener('mouseleave', scheduleClose);
    });

    // Click outside closes any open menu
    document.addEventListener('click', function(e){
      if(!e.target.closest('.js-nav-link') && !e.target.closest('.js-mega-menu')){
        scheduleClose();
      }
    });
  }

  function bindMobileMenu(){
    var open  = document.querySelector('.js-hamburger-open');
    var close = document.querySelector('.js-hamburger-close');
    var bg    = document.querySelector('.js-mobile-backdrop');
    var menu  = document.querySelector('.js-mobile-menu');
    function show(){ if(menu) menu.classList.add('is-open'); if(bg) bg.classList.add('is-open'); document.body.classList.add('menu-open'); }
    function hide(){ if(menu) menu.classList.remove('is-open'); if(bg) bg.classList.remove('is-open'); document.body.classList.remove('menu-open'); }
    if(open) open.addEventListener('click', show);
    if(close) close.addEventListener('click', hide);
    if(bg) bg.addEventListener('click', hide);

    document.querySelectorAll('.js-mnav-head').forEach(function(btn){
      btn.addEventListener('click', function(){
        var g = btn.closest('.m-nav-group');
        if(g) g.classList.toggle('is-open');
      });
    });
  }

  function bindScrollHide(){
    var nav = document.querySelector('.js-nav-top');
    if(!nav) return;
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var y = window.scrollY, dy = y - lastY;
        if(y < 80) nav.classList.remove('is-hidden');
        else if(dy > 6) nav.classList.add('is-hidden');
        else if(dy < -6) nav.classList.remove('is-hidden');
        lastY = y;
        ticking = false;
      });
    }, {passive: true});
  }

  function bindLangPill(){
    document.querySelectorAll('.js-lang-pill').forEach(function(btn){
      btn.addEventListener('click', function(){
        var span = btn.querySelector('.js-lang-label');
        if(span) span.textContent = (span.textContent.trim() === 'EN') ? 'FR' : 'EN';
      });
    });
  }

  function init(){
    bindMegaMenu();
    bindMobileMenu();
    bindScrollHide();
    bindLangPill();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
